<fw-dialog width="medium" *ngIf="{progress: progress$ | async} as data">
  <fw-dialog-header>
    <h3>{{ 'importDetailsDialog.header' | translate }}</h3>
  </fw-dialog-header>
  <fw-dialog-content class="import-details-content">

    <operation-info [path]="('common.labels.source' | translate) + ': ' + xferImport.storage_url"
      [subTitle]="'importDetailsDialog.labels.createdByOn' | translate | interpolate: createdBy:(xferImport.created | date:'mediumDate')"
      [title]="xferImport.label" [id]="xferImport._id"></operation-info>

    <fw-alert *ngIf="data.progress?.status2 === status.Pending" severity="info" icon="information-circle"
      [title]="'importDetailsDialog.status.pending.title' | translate"
      [description]="'importDetailsDialog.status.pending.description' | translate"></fw-alert>

    <ng-container *ngIf="data.progress; else loading">
      <operation-table-with-progress [progressBarStatusColor]="progressBarStatusColor"
        [progressBarStatusText]="progressBarStatusText ? (progressBarStatusText | translate) : ''"
        [progressBarColor]="progressBarColor" [progress]="data.progress">
        <div class="import-details-content-body">
          <div class="import-details-content-body-item">
            <operations-details-table [isWithTotal]="true"
              [title]="'importDetailsDialog.labels.fileStatistics' | translate" [tableConfig]="fileStatisticsTableData"
              icon="media-library-imports-dowload"></operations-details-table>
          </div>

          <div class="import-details-content-body-item">
            <operations-details-table [isSmall]="true"
              [title]="'importDetailsDialog.labels.impactedContainers' | translate" [tableConfig]="impactedContainers"
              icon="data-tree"></operations-details-table>
            <operations-details-table [isSmall]="true" iconColor="green"
              [title]="'importDetailsDialog.labels.malwareDetection' | translate " [tableConfig]="malwareDetection"
              icon="shield-protect"></operations-details-table>
          </div>
        </div>
      </operation-table-with-progress>
    </ng-container>

    @if (alertSeverity) {
    <fw-alert [severity]="alertSeverity" [icon]="alertIcon" [title]="alertTitle | translate">
      @if (statusReason) {
      <span class="import-details-status-reason">{{ statusReason }}</span>
      <br />
      }
      <span [innerHtml]="alertDescription | translate | interpolate : alertDescriptionCount | trusthtml"></span>
    </fw-alert>
    }
  </fw-dialog-content>
  <fw-dialog-actions class="import-details-actions">
    <div class="import-details-actions-item">
      <fw-tooltip *ngIf="!isCancelling; else cancellingProgressButton"
        [title]=" !isStarting ? ('importDetailsDialog.actions.cancelImportTooltip' | translate) : ''"><fw-button
          (click)="cancelImport()" [disabled]="!isStarting" leftIcon="close-circled" color="danger"
          variant="outline">{{'importDetailsDialog.actions.cancelImport' | translate}}</fw-button></fw-tooltip>
      <ng-template #cancellingProgressButton>
        <fw-button [disabled]="false" color="danger"
          variant="progress">{{'importDetailsDialog.actions.cancellingImport' | translate}}</fw-button>
      </ng-template>
      <fw-tooltip [title]="isFinished ? '' : 'importDetailsDialog.actions.downloadReportTooltip' | translate"><fw-button
          (click)="downloadReport(data.progress)" [disabled]="!isFinished" leftIcon="download" color="primary"
          variant="outline">{{'importDetailsDialog.actions.downloadImportReport' | translate}}</fw-button></fw-tooltip>
      <fw-button *ngIf="xferImport.has_conflicts" (click)="downloadConflictReport(data.progress)"
        [disabled]="!isFinished" leftIcon="download" color="primary"
        variant="outline">{{'importDetailsDialog.actions.downloadConflictReport' | translate}}</fw-button>
    </div>
    <div class="import-details-actions-item">
      <div>
        <fw-tooltip *ngIf="xferImport.can_rerun"
          [title]="isFinished ? '' : 'importDetailsDialog.actions.reRunTooltip' | translate">
          <fw-button (click)="rerunImport()" [disabled]="!isFinished" leftIcon="arrow-rotate" color="primary"
            variant="outline">{{'common.actions.reRun' | translate}}</fw-button>
        </fw-tooltip>
      </div>
      <fw-button (click)="dialogRef.close()">{{ 'common.actions.close' | translate }}</fw-button>
    </div>
  </fw-dialog-actions>
</fw-dialog>

<ng-template #loading>
  <fw-loading></fw-loading>
</ng-template>
